var map = {
	"./Googleplus.svg": 504,
	"./IG.svg": 505,
	"./arrow-down-dark.svg": 506,
	"./arrow.svg": 507,
	"./carrot.svg": 508,
	"./clock.svg": 509,
	"./computer.svg": 510,
	"./credit-card.svg": 511,
	"./fb.svg": 512,
	"./location.svg": 513,
	"./logo_white.svg": 514,
	"./money.svg": 515,
	"./percent.svg": 516,
	"./phone.svg": 517,
	"./pinterest.svg": 518,
	"./quotes.svg": 519,
	"./star-01.svg": 520,
	"./summers_logo.svg": 521,
	"./twitter.svg": 522,
	"./youtube.svg": 523
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 602;


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.svg$
// module id = 602
// module chunks = 1